import { t } from '@base/utils/helpers';
import { Fragment } from 'react';
import { MinutesPerMove } from '../constants/minutesPerMove';
import styles from '../styles/createTableTimePerMove.module.scss';


export const CreateTableTimePerMove = (props: {
  value: number;
  handlerTimePerMove: (value: number) => void;
  disabled?: boolean;
}) => {
  return (
    <div>
      <div>
        <div>{t('minutes_per_move')}</div>
      </div>
      <section className={styles.radioGroup}>
        {MinutesPerMove.map(({title, value }) => (
          <Fragment key={title}>
            <input
              type="radio"
              id={`time_per_move_${title}`}
              name="time_per_move"
              checked={props.value === value}
              className={props.disabled ? 'disabled' : undefined}
              onChange={() => props.handlerTimePerMove(value)}
            />
            <label htmlFor={`time_per_move_${title}`}>
              <span>{title}</span>
            </label>
          </Fragment>
        ))}
      </section>
    </div>
  );
};
